import { render } from "./riskList2.vue?vue&type=template&id=7d3072df&scoped=true"
import script from "./riskList2.vue?vue&type=script&lang=js"
export * from "./riskList2.vue?vue&type=script&lang=js"

import "./riskList2.vue?vue&type=style&index=0&id=7d3072df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d3072df"

export default script